// 17 시도 상수 별칭 — 클라이언트·서버 양쪽에서 import 가능(localStorage 저장 헬퍼는 호출처 0 이라 제거).
// 서버 IP geolocation (next/headers) 은 region-detection.ts 에 분리.

// hc3 통합(HC-A-217) — 17 시도 목록 정본은 lib/regions REGIONS(같은 값·같은 순서). 여기는 이름 호환 별칭.
import { REGIONS } from '@/lib/regions';
export const KR_REGIONS_17 = REGIONS;

